import type { LocalSpecialty } from '@/core/graphql/generated/types';

type ProfileWithLocalSpecialties = {
	localSpecialties: LocalSpecialty[];
};

export const getLocalSpecialtyValue = (
	profile: ProfileWithLocalSpecialties | null | undefined
) =>
	profile?.localSpecialties?.map(s => ({
		id: s.code,
		name: s.name
	})) ?? [];
